// extracted by mini-css-extract-plugin
module.exports = {"selector":"VerticalTabSection-module__selector___3r0NG","selected":"VerticalTabSection-module__selected___1pq15"};